'use strict';

var modAnimationItem_v4 = function( options ) {

    const self = this;

    this.step = function( nowIncr ) {
        // te nekā nav jo šo aizvietos ar kādu no __step funkcijām;
    };

    this.init( options );

};

modAnimationItem_v4.prototype.init = function( options ) {
    var defaults = {
        // TODO: stopAt
        //stopAt: 'end'        // end | groupend | anypos
        autoHide: true
    };

    this.options = $.extend( {},
        defaults,
        options || {} );


    this.animationList = null;
    this.animationListIdx = null;
    this.animationStackIdx = null;


    this.element = $();
    this.duration = 0;
    this.delay = 0;
    this.hasAnimation = false;

    this.status = 'waiting';
    // waiting | playing | finished
    this.action = null;
    // finish | playing | stopping | restarting;
    this.isClone = false;


    this.canMultiply = true;
    this.autoRemoveClone = true;
    this.autoHide = this.options.autoHide ?? true;
    this.restartClones = false;
    this.loopClones = false;
    this.noRestartIfStopping = true;


    this.multiply = false;
    this.loop = false;
    this.visible = false;

    this.width = null;
    this.height = null;
    this.widthDiv = null;
    this.heightDiv = null;


    this.startOpts = {};
    this.animList = [];
    this.animLength = 0;

    //this.sizeFactor = 1;    // šo laikam vairs neizmantojam jo lietojam relatīvos % nevis px izmērus un pozīcijas;
    this.timeFactor = 1;


    this.setOptions( options );
};

modAnimationItem_v4.prototype.setList = function( animationList, animationListIdx, isClone ) {
    this.animationList = animationList;
    this.animationListIdx = animationListIdx;
    this.isClone = isClone || false;
};
modAnimationItem_v4.prototype.setStack = function( animationStackIdx ) {
    this.animationStackIdx = animationStackIdx;
};

// animācijas izveidei;

modAnimationItem_v4.prototype.setOptions = function( options ) {
    const self = this;

    $.each( options, function( idx, value ) {
        switch ( idx ) {
            case 'element':
                self.setElement( value );
                break;

            case 'size':
                self.setSize( value );
                break;

            case 'duration':
                self.setDuration( value );
                break;

            case 'startOpts':
                self.setStartOpts( value );
                break;

            case 'loop':
                self.setLoop( value );
                break;
            case 'multiply':
                self.setMultiply( value );
                break;

            /* case 'sizeFactor':
                self.setSizeFactor( value );
                break; */

            case 'timeFactor':
                self.setTimeFactor( value );
                break;

            case 'animdata':
                self.setAnimdata( value );
                break;

            default:
                self.options[ idx ] = value;
                break;
        }
    } );
};

modAnimationItem_v4.prototype.setElement = function( element ) {
    this.element = element ? $( element ) : $();
    return this;
};
modAnimationItem_v4.prototype.setSize = function( size ) {
    this.width = size.width;
    this.height = size.height;
    this.widthDiv = this.width / 100;
    this.heightDiv = this.height / 100;
    return this;
};
modAnimationItem_v4.prototype.setDuration = function( duration ) {
    this.duration = duration || 0;
    return this;
};
modAnimationItem_v4.prototype.setStartOpts = function( startOpts ) {
    //this.startOpts = startOpts || {};
    this.startOpts = $.extend( true, {}, startOpts || {} );
    return this;
};
modAnimationItem_v4.prototype.setLoop = function( loop ) {
    this.loop = loop ? true : false;
    //this.canMultiply = !this.loop;
    return this;
};
modAnimationItem_v4.prototype.setMultiply = function( multiply ) {
    this.multiply = multiply;
    //this.canMultiply = !this.loop;
    return this;
};
/* modAnimationItem_v4.prototype.setSizeFactor = function( sizeFactor ) {
    this.sizeFactor = sizeFactor || 1;
    return this;
}; */
modAnimationItem_v4.prototype.setTimeFactor = function( timeFactor ) {
    this.timeFactor = timeFactor || 1;
    return this;
};

modAnimationItem_v4.prototype.setAnimList = function( animList ) {
    const self = this;

    //this.animList = animList || [];
    this.animList = $.extend( true, [], animList || {} );
    this.animLength = this.animList.length;

    this.hasAnimation = false;

    if (this.animLength > 0) {
        // pārbaudam vai kādā grupā ir animācija;
        $.each( this.animList, function( idx, animGroup ) {
            // ja nav duration joprojām var būt animācija ka vienkārši pārlec uz doto pozīciju vai transform;
            if (animGroup.list.length > 0) {
                self.hasAnimation = true;
                return false;
            }
        } );
    }

    if (!this.hasAnimation) {
        this.autoHide = false;
    }

    return this;
};

modAnimationItem_v4.prototype.setAnimdata = function( animdata ) {
    this.animdata = animdata;

    if (animdata.duration) {
        this.setDuration( animdata.duration );
    }

    if (animdata.startOpts) {
        this.setStartOpts( animdata.startOpts );
    }

    if (animdata.list) {
        this.setAnimList( animdata.list );
    }
/* {
"duration": 2000,
"startOpts": {
"translate": {
  "x": -62,
  "y": -63
},
"scale": {
  "x": 1,
  "y": 1
},
"rotate": 0,
"opacity": 1,
"blurall": 0
},
"list": [
{
  "groupId": 1,
  "duration": 2000,
  "list": [
    {
      "type": "move-circular",
      "value": {
        "x": {
          "from": -62,
          "to": -62
        },
        "y": {
          "from": -63,
          "to": -63
        },
        "cx": 0,
        "cy": 0,
        "r": 88.3911760301898,
        "angleIncr": 360,
        "angleTo": 225.45835645800042,
        "angleCurr": -134.54164354199958,
        "angleDiff": 360
      },
      "time": {
        "from": 0,
        "to": 2
      }
    },
    {
      "type": "rotate",
      "valuediff": 360,
      "time": {
        "from": 0,
        "to": 2,
        "duration": 2
      }
    }
  ]
}
]
} */

    return this;
};


// ...
modAnimationItem_v4.prototype.setAction = function( action ) {
    if (this.noRestartIfStopping) {
        if (this.action == 'stopping' && action == 'restarting') {
            //console.log('SKIP RESTART');
            return;
        }
    }

    /* if (action == 'restarting') {
        action = 'stopping';
    } */

    this.action = action;

    // TODO:
    if (this.action == 'playing') {
        //this.status = 'playing';
    }
    else if (this.action == 'stopping') {

    }
    else if (this.action == 'restarting') {

    }
    else if (this.action == 'finish') {

    }
};

modAnimationItem_v4.prototype.getDuration = function( /* noDelay */ ) {
    /* if (noDelay) {
        return this.duration;
    }
*/
    return this.duration + this.delay;
};

modAnimationItem_v4.prototype.update = function() {

};


// animācijai
modAnimationItem_v4.prototype.transformFix = function( animOpts ) {
    const self = this;

    //console.log(animOpts);
    return [
        ( animOpts.translate ? 'translate('+(animOpts.translate.x / self.widthDiv)+'%, '+(animOpts.translate.y / self.heightDiv)+'%)' : ''),
        ( animOpts.scale ? 'scale('+animOpts.scale.x+')' : ''),
        ( animOpts.rotate ? 'rotate('+animOpts.rotate+'deg)' : '')
    ].join(' ');
    //return 'translate('+(animOpts.translate.x / self.widthDiv)+'%, '+(animOpts.translate.y / self.heightDiv)+'%) scale('+animOpts.scale.x+') rotate('+animOpts.rotate+'deg)';
};

modAnimationItem_v4.prototype.reset = function( fromLoop ) {
    if ( fromLoop && this.isClone && !this.loopClones ) {
        return;
    }

    //console.log('animation.multiply reset', this.options);

    // resetojam animāciju uz sākuma pozīciju;
    this.css = {};
    this.css.transform = this.transformFix( this.startOpts );
    modAnimCalc.applyCss( this.css, this.startOpts );
    this.element.css( this.css ).css({
        display: ''
    });
    //console.log( 'startOpts', this.startOpts, this.css );

    //alert();
    // klonējam starta pozīciju uz animācijas pozīciju
    this.animOpts = $.extend( true, {}, this.startOpts );

    // atiestatam ka nav done, ja iepriekš uzlikts kā done;
    $.each( this.animList, function( idx, animGroup ) {
        if (animGroup.done) {
            animGroup.done = false;
        }

        if (animGroup.list.length > 0) {
            $.each( animGroup.list, function( idx, animTransform ) {
                if (animTransform.done) {
                    animTransform.done = false;
                }
            } );
        }
    } );

    this.finished = false;


    this.resetTimeline();
};

modAnimationItem_v4.prototype.resetTimeline = function() {
    // pirmā grupa palaižas uzreiz ja nav delay;
    this.durationOffset = 0;
    this.durationBreakpoint = this.delay;
    this.currentListIdx = -1;
    this.currentListItem = null;
    if (this.delay) {
        this.setDelayStep();
    } else {
        this.setNextStep();
    }

    this.nowreal = 0;
    this.now = 0;

    this.status = 'playing';
};


modAnimationItem_v4.prototype.__stepDelay = function( nowIncr ) {
    this.nowreal += nowIncr;
    this.now = this.nowreal - this.durationOffset;

    if (this.now >= this.durationBreakpoint) {
        const prevIdx = this.currentListIdx;

        this.setNextStep();

        if (prevIdx != this.currentListIdx) {
            // palaižam arī nākošo step ja now ir lielāks
            this.step( 0 );
        }
    }
};

modAnimationItem_v4.prototype.__stepFinished = function( nowIncr ) {
    this.nowreal += nowIncr;
    return false;
};

modAnimationItem_v4.prototype.__stepDefault = function( nowIncr ) {
    this.nowreal += nowIncr;
    this.now = this.nowreal - this.durationOffset;

    if (this.now >= this.durationBreakpoint) {
        this.animateCurrent( this.durationBreakpoint, true );

        const prevIdx = this.currentListIdx;

        this.setNextStep();

        if (prevIdx != this.currentListIdx) {
            // palaižam arī nākošo step ja now ir lielāks par 0 (self.nowreal - self.durationOffset;)
            this.step( 0 );
        }

        return;
    }

    this.animateCurrent( this.now, false );
};


modAnimationItem_v4.prototype.setDelayStep = function() {
    this.step = this.__stepDelay;
};

modAnimationItem_v4.prototype.setFinishedStep = function() {
    this.step = this.__stepFinished;
};

modAnimationItem_v4.prototype.setNextStep = function() {
    ++this.currentListIdx;

    if (this.currentListIdx >= this.animLength) {
        this.setDone();
        return false;
    }

    this.step = this.__stepDefault;

    this.currentOpts = $.extend( true, {}, this.animOpts );
    this.currentListItem = this.animList[ this.currentListIdx ];
    this.durationOffset += this.durationBreakpoint;
    this.durationBreakpoint = this.currentListItem.duration;
};

modAnimationItem_v4.prototype.setDone = function() {
    const startDiff = this.now > this.durationBreakpoint ? this.now - this.durationBreakpoint : 0;
    let loop = this.loop && !this.finished,
        beforeFinished = this.finished;

    if (this.action == 'stopping') {
        this.action = null;
        loop = false;
    }
    else if (this.action == 'restarting') {
        this.action = null;

        let skipRestart = this.isClone && !this.restartClones;

        if (!skipRestart) {
            loop = this.loop;

            if (beforeFinished) {
                this.animationList.itemRestarted( this.animationListIdx, this.animationStackIdx, this );
            }

            beforeFinished = false;
            this.finished = false;
        }
    }

    if (loop) {
        // ja ir loop, tad resetojam pozīciju un sākam no sākuma;
        this.reset( true );
    } else {
        // ja nav loop, tad resetojam taimlainu un sākam no sākuma; ar finished = true;
        //this.setFinishedStep();
        this.resetTimeline();
        this.finished = true;
        this.status = 'finished';

        if (!beforeFinished) {
            this.animationList.itemFinished( this.animationListIdx, this.animationStackIdx, this );
        }
    }

    this.nowreal = startDiff;
    this.now = startDiff;
};


modAnimationItem_v4.prototype.animateCurrent = function( now, finishRun ) {
    if (now < 0 || this.finished) {
        // skipojam ja ir izsaukts par ātru vai jau ir beidzies;
        return;
    }

    modAnimCalc.calcOpts( now, this.currentListItem.duration, this.currentListItem,  this.animOpts, this.currentOpts );

    this.css.transform = this.transformFix( this.animOpts );
    modAnimCalc.applyCss( this.css, this.animOpts );
    this.element.css( this.css );

    /*
    if (currentTimefield) {
        currentTimefield.html( nowTime.toFixed( 2 ) );
    }
    */
};


modAnimationItem_v4.prototype.clone = function() {
    var $imageClone = this.element.clone().css({
        display: 'none'
    });
    this.element.parent().append( $imageClone );

    var clone = new modAnimationItem_v4({
        element: $imageClone,
        size: {
            width: this.width,
            height: this.height
        },
        loop: this.loop && this.loopClones,
        //sizeFactor: this.sizeFactor,
        animdata: this.animdata
    });

    return clone;
};

modAnimationItem_v4.prototype.remove = function() {
    this.element.remove();

    this.animationList = null;
    this.animationListIdx = null;
    this.animationStackIdx = null;

    this.duration = null;
    this.delay = null;
    this.hasAnimation = null;

    this.status = null;
    // waiting | playing | finished
    this.action = null;
    // finish | playing | stopping | restarting;
    this.isClone = null;


    this.canMultiply = null;
    this.autoRemoveClone = null;
    this.autoHide = null;
    this.restartClones = null;
    this.loopClones = null;
    this.noRestartIfStopping = null;


    this.multiply = null;
    this.loop = null;
    this.visible = null;

    this.width = null;
    this.height = null;
    this.widthDiv = null;
    this.heightDiv = null;


    this.startOpts = null;
    this.animList = null;
    this.animLength = null;

    //this.sizeFactor = null;
    this.timeFactor = null;

};

modAnimationItem_v4.prototype.hide = function() {
    //console.log('hide');
    this.element.css( this.css ).css({
        display: 'none'
    });
};


window.modAnimationItem_v4 = modAnimationItem_v4;